<template>
  <div class="card mgt-20px" id="factureAchat">
    <header class="header-card">
      <p>
        {{ $t('detailFacture.achatVenteInterne.vente.factureAchat.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('detailFacture.achatVenteInterne.vente.factureAchat.factureAchat')"
                   custom-class="has-text-default is-italic has-text-weight-light mgb-0">
            <router-link-blank :message="facture.referenceClient"
                               :to="{ name: 'c.bodac.factures-achatVenteInterne',
                                      params: { id: facture.referenceExterne } }"
                               class-message="lien">
            </router-link-blank>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    facture: {
      type: Object,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
};

</script>
